// extracted by css-extract-rspack-plugin
export default {"emphasis":"content-editor-plugin-emphasis-Emphasis-emphasis-ec9c7edf"};